import React from 'react';

import { BaseIconProps } from '.';

export const Fullscreen = ({ fill }: BaseIconProps) => (
  <g transform="scale(2.109375)">
    <g>
      <path
        d="M 191.142,162.858 68.285,40 H 147 c 11.046,0 20,-8.954 20,-20 C 167,8.954 158.046,0 147,0 H 60 C 26.916,0 0,26.916 0,60 v 87 c 0,11.046 8.954,20 20,20 11.046,0 20,-8.954 20,-20 V 68.285 l 122.858,122.858 c 3.905,3.905 9.023,5.857 14.142,5.857 5.119,0 10.237,-1.952 14.142,-5.857 7.811,-7.811 7.811,-20.475 0,-28.285 z"
        stroke={fill}
      />
    </g>
    <g>
      <path
        d="m 191.142,320.858 c -7.811,-7.81 -20.474,-7.811 -28.284,-10e-4 L 40,443.715 V 365 C 40,353.954 31.046,345 20,345 8.954,345 0,353.954 0,365 v 87 c 0,33.084 26.916,60 60,60 h 87 c 11.046,0 20,-8.954 20,-20 0,-11.046 -8.954,-20 -20,-20 H 68.285 L 191.142,349.143 c 7.811,-7.811 7.811,-20.475 0,-28.285 z"
        stroke={fill}
      />
    </g>
    <g>
      <path
        d="m 492,345 c -11.046,0 -20,8.954 -20,20 v 78.715 L 349.142,320.857 c -7.811,-7.811 -20.474,-7.811 -28.284,0 -7.81,7.811 -7.811,20.475 0,28.285 L 443.715,472 H 365 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 h 87 c 33.084,0 60,-26.916 60,-60 v -87 c 0,-11.046 -8.954,-20 -20,-20 z"
        stroke={fill}
      />
    </g>
    <g>
      <path
        d="m 452,0 h -87 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 h 78.715 L 320.858,162.857 c -7.811,7.811 -7.811,20.475 0,28.285 3.905,3.906 9.023,5.858 14.142,5.858 5.119,0 10.237,-1.952 14.142,-5.857 L 472,68.285 V 147 c 0,11.046 8.954,20 20,20 11.046,0 20,-8.954 20,-20 V 60 C 512,26.916 485.084,0 452,0 Z"
        stroke={fill}
      />
    </g>
  </g>
);
